/* ============================================
   Delivery Day Auto-Replace (Locale-aware)
   ----------------------------------------------
   Vervangt "morgen" met de actuele bezorg-dag
   in elk element met `data-auto-delivery`.

   Mapping (orderdag → bezorgdag):
     Maandag    → Dinsdag
     Dinsdag    → Woensdag
     Woensdag   → Donderdag
     Donderdag  → Vrijdag
     Vrijdag    → Zaterdag
     Zaterdag   → Dinsdag (skipt zo + ma)
     Zondag     → Dinsdag

   Tijdzone: Europe/Amsterdam (NL).
   Run on initial load + Shopify section reload events.
   ============================================ */
(function () {
  'use strict';

  // Detect locale from document lang attribute
  function getLocale() {
    var lang = document.documentElement.lang || 'nl';
    return lang.toLowerCase().split('-')[0];
  }

  // Delivery day labels by locale
  var DELIVERY_LABELS = {
    de: {
      Sun: 'Dienstag', Mon: 'Dienstag', Tue: 'Mittwoch',
      Wed: 'Donnerstag', Thu: 'Freitag', Fri: 'Samstag', Sat: 'Dienstag'
    },
    en: {
      Sun: 'Tuesday', Mon: 'Tuesday', Tue: 'Wednesday',
      Wed: 'Thursday', Thu: 'Friday', Fri: 'Saturday', Sat: 'Tuesday'
    },
    fr: {
      Sun: 'mardi', Mon: 'mardi', Tue: 'mercredi',
      Wed: 'jeudi', Thu: 'vendredi', Fri: 'samedi', Sat: 'mardi'
    },
    nl: {
      Sun: 'Dinsdag', Mon: 'Dinsdag', Tue: 'Woensdag',
      Wed: 'Donderdag', Thu: 'Vrijdag', Fri: 'Zaterdag', Sat: 'Dinsdag'
    }
  };

  // Fallback by index for old browsers [Sun, Mon, Tue, Wed, Thu, Fri, Sat]
  var FALLBACK_BY_LOCALE = {
    de: ['Dienstag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag','Dienstag'],
    en: ['Tuesday','Tuesday','Wednesday','Thursday','Friday','Saturday','Tuesday'],
    fr: ['mardi','mardi','mercredi','jeudi','vendredi','samedi','mardi'],
    nl: ['Dinsdag','Dinsdag','Woensdag','Donderdag','Vrijdag','Zaterdag','Dinsdag']
  };

  // Tomorrow/morgen patterns by locale
  var PATTERNS_BY_LOCALE = {
    de: [
      /\bam\s+nächsten\s+Werktag\b/gi,
      /\bnächsten\s+Werktag\b/gi,
      /\bmorgen\b/gi
    ],
    en: [
      /\bthe\s+next\s+business\s+day\b/gi,
      /\bnext\s+business\s+day\b/gi,
      /\btomorrow\b/gi
    ],
    fr: [
      /\ble\s+prochain\s+jour\s+ouvrable\b/gi,
      /\bprochain\s+jour\s+ouvrable\b/gi,
      /\bdemain\b/gi
    ],
    nl: [
      /\bde\s+volgende\s+werkdag\b/gi,
      /\bvolgende\s+werkdag\b/gi,
      /\bmorgen\b/gi
    ]
  };

  function getDeliveryDay() {
    var locale = getLocale();
    var labels = DELIVERY_LABELS[locale] || DELIVERY_LABELS.nl;
    var fallback = FALLBACK_BY_LOCALE[locale] || FALLBACK_BY_LOCALE.nl;

    try {
      var formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Amsterdam',
        weekday: 'short'
      });
      var short = formatter.format(new Date());
      return labels[short] || fallback[new Date().getDay()];
    } catch (e) {
      return fallback[new Date().getDay()];
    }
  }

  function hasMatch(text, patterns) {
    for (var i = 0; i < patterns.length; i++) {
      patterns[i].lastIndex = 0;
      if (patterns[i].test(text)) return true;
    }
    return false;
  }

  function replaceTextNode(node, label, patterns) {
    var text = node.nodeValue;
    if (!hasMatch(text, patterns)) return;
    patterns.forEach(function (re) {
      re.lastIndex = 0;
      text = text.replace(re, label);
    });
    node.nodeValue = text;
  }

  function walkAndReplace(root, label, patterns) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodesToProcess = [];
    var node;
    while ((node = walker.nextNode())) {
      if (hasMatch(node.nodeValue, patterns)) {
        nodesToProcess.push(node);
      }
    }
    nodesToProcess.forEach(function (n) { replaceTextNode(n, label, patterns); });
  }

  function update(scope) {
    var locale = getLocale();
    var patterns = PATTERNS_BY_LOCALE[locale] || PATTERNS_BY_LOCALE.nl;
    var label = getDeliveryDay();
    var root = scope || document;
    var elements = root.querySelectorAll('[data-auto-delivery]');
    elements.forEach(function (el) {
      walkAndReplace(el, label, patterns);
      // Mark as processed zodat we niet dubbel vervangen
      el.dataset.deliveryReplaced = label;
    });

    // Templates met expliciete {day} placeholder
    var templated = root.querySelectorAll('[data-delivery-day]');
    templated.forEach(function (el) {
      var template = el.dataset.deliveryTemplate || el.getAttribute('data-delivery-template') || '<strong>Voor 23:59 besteld</strong> = {day} in huis';
      el.innerHTML = template.replace(/\{day\}/g, label);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { update(); });
  } else {
    update();
  }

  // Re-run wanneer Shopify section opnieuw gerendered wordt (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    update(e.target);
  });

  // Custom event voor scripts die nieuwe content injecteren (wishlist, recently viewed)
  document.addEventListener('delivery-day:refresh', function (e) {
    update(e.detail && e.detail.scope ? e.detail.scope : null);
  });

  // Universele hook: cards:rendered event wordt door alle product-row sections
  // gedispatched (row-trending, recently-viewed, wishlist, atc-modal upsells, etc).
  // Hierdoor krijgen ALLE dynamisch toegevoegde cards automatisch de bezorg-dag
  // tekst zonder dat elke section apart delivery-day:refresh hoeft te dispatchen.
  document.addEventListener('cards:rendered', function (e) {
    update(e.detail && e.detail.scope ? e.detail.scope : null);
  });

  // Globale helper voor inline scripts
  window.candyDeliveryDay = {
    get: getDeliveryDay,
    refresh: function (scope) { update(scope); }
  };
})();
